module.exports = __webpack_public_path__ + "static/media/cloud1.ce082b01.svg";